import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import QRLanding from "@/pages/QRLanding";
import BrandSelection from "@/pages/BrandSelection";
import MenuBrowsing from "@/pages/MenuBrowsing";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import KioskEntry from "@/pages/KioskEntry";
import AdminLogin from "@/pages/AdminLogin";
import MenuManagement from "@/pages/MenuManagement";
import KitchenDashboard from "@/pages/KitchenDashboard";

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin-vow");

  return (
    <div className={isAdmin ? "admin-container" : "mobile-container"}>
      <Routes>
        <Route path="/" element={<QRLanding />} />
        <Route path="/kiosk" element={<KioskEntry />} />
        <Route path="/room/:roomNumber" element={<BrandSelection />} />
        <Route path="/menu/:roomNumber/:brandName" element={<MenuBrowsing />} />
        <Route path="/cart/:roomNumber/:brandName" element={<Cart />} />
        <Route path="/checkout/:roomNumber/:brandName" element={<Checkout />} />
        <Route path="/confirmation/:orderId" element={<OrderConfirmation />} />
        <Route path="/admin-vow" element={<AdminLogin />} />
        <Route path="/admin-vow/menu" element={<MenuManagement />} />
        <Route path="/admin-vow/kitchen" element={<KitchenDashboard />} />
        <Route path="/admin" element={<Navigate to="/" replace />} />
        <Route path="/admin/*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" />
    </div>
  );
}

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
